export default __webpack_public_path__ + "assets/images/1c50f85a263615b53acba26292d620e0.svg";